export const sxConfig = {
  fieldColor: {
    '& .MuiInputLabel-standard': {
      color: '#fff',
      '&.Mui-focused': {
        color: '#fff',
      },
    },
    '& .MuiInputBase-input': {
      color: '#fff',
    },
    '& .MuiSvgIcon-root': {
      color: '#fff',
    },
  },
};
